<p class="completed" *ngIf="(folderStatuses.SUCCESS == item.status || isSuccess) && item.latestCompletedAt">
    <svg  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="{'inside-folder-svg': invoicesFolderID !== null}">
        <path d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6
    11.8L5.75
    8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667
    19.7373
    6.1 19.212C4.88333 18.6873 3.825 17.975 2.925
    17.075C2.025
    16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833
    0
    11.3833
    0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267
    4.88333
    2.025 3.825 2.925 2.925C3.825 2.025 4.88333
    1.31233 6.1
    0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0
    12.6833
    0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025
    17.075
    2.925C17.975 3.825 18.6873 4.88333 19.212
    6.1C19.7373
    7.31667 20 8.61667 20 10C20 11.3833 19.7373
    12.6833
    19.212
    13.9C18.6873 15.1167 17.975 16.175 17.075
    17.075C16.175
    17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373
    11.3833
    20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675
    15.675C17.225 14.125 18 12.2333 18 10C18 7.76667
    17.225
    5.875 15.675 4.325C14.125 2.775 12.2333 2 10
    2C7.76667 2
    5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2
    10C2
    12.2333
    2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18
    10
    18Z" fill="#1E31CF" />
    </svg>&nbsp;
    Completed: {{item.latestCompletedAt | date : 'd MMM y \'at\'
    HH:mm:ss'}}
</p>

<p class="error" *ngIf="folderStatuses.FAILED ==
  item.status">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.4 15L10 11.4L13.6 15L15 13.6L11.4
      10L15
      6.4L13.6
      5L10 8.6L6.4 5L5 6.4L8.6 10L5 13.6L6.4 15ZM10
      20C8.61667
      20 7.31667 19.7373 6.1 19.212C4.88333 18.6873
      3.825
      17.975
      2.925 17.075C2.025 16.175 1.31267 15.1167 0.788
      13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667
      0.262667
      7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825
      2.925
      2.925C3.825 2.025 4.88333 1.31233 6.1
      0.787C7.31667
      0.262333 8.61667 0 10 0C11.3833 0 12.6833
      0.262333
      13.9
      0.787C15.1167 1.31233 16.175 2.025 17.075
      2.925C17.975
      3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667
      20
      8.61667 20 10C20 11.3833 19.7373 12.6833 19.212
      13.9C18.6873 15.1167 17.975 16.175 17.075
      17.075C16.175
      17.975 15.1167 18.6873 13.9 19.212C12.6833
      19.7373
      11.3833
      20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675
      15.675C17.225 14.125 18 12.2333 18 10C18 7.76667
      17.225
      5.875 15.675 4.325C14.125 2.775 12.2333 2 10
      2C7.76667
      2
      5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2
      10C2
      12.2333 2.775 14.125 4.325 15.675C5.875 17.225
      7.76667
      18
      10 18Z" fill="#BA1A1A" />
    </svg>&nbsp;
    Failed: {{item.latestCompletedAt | date : 'd MMM y \'at\'
    HH:mm:ss'}}
</p>


<p class="normal" *ngIf="!item.status || item.status == folderStatuses.INIT || item.status == folderStatuses.CANCELED   && !hideOnCreated">
    Created at {{item.createdAt | date : 'd MMM y \'at\'
    HH:mm:ss'}}
</p>


<p class="completed" *ngIf="(isProcessing(getStatus(item)) && !isSuccess)">
    <mat-spinner strokeWidth="2" diameter="25"></mat-spinner>
    &nbsp;
    Processing, please wait...
</p>
